import cn from 'classnames';
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IModule } from '@api/types/general';
import { BREAKPOINTS } from '@consts/ui';
import Button from '@components/button';
import RecentGameItem from './recent-game-item';
import useReduxState from '@hooks/useReduxState';
import styles from './recent.module.scss';
import useJackpotRoom from '@hooks/useJackpotRoom';

const RECENT_GAME_ITEM_WIDT = 320;
const SWIPER_DEFAULT_SLIDES = 3.5;

const RecentGames = ({ className = '' }: IModule): JSX.Element => {
    const [
        {
            jackpot: { rooms },
            ui,
        },
    ] = useReduxState((state) => state);

    const { currentRoom } = useJackpotRoom();
    const [lastElementReached, setLastElementReached] =
        useState<boolean>(false);

    const swiperRef = useRef<HTMLInputElement>(null);

    const { recent_games } = rooms[currentRoom];

    const roundHalf = (value: number): number =>
        Number((Math.round(value * 2) / 2).toFixed(1));

    const handleShadowIndicator = (isLastSlide: boolean): void => {
        if (ui.windowWidth < BREAKPOINTS.LG) return;

        setLastElementReached(isLastSlide);
    };

    const handleSwiperSlides = (): number =>
        swiperRef.current
            ? roundHalf(swiperRef.current.clientWidth / RECENT_GAME_ITEM_WIDT)
            : SWIPER_DEFAULT_SLIDES;

    /* Components */

    const recentGames: JSX.Element[] = recent_games.map((game) => {
        // console.log(game);
        return (
            <SwiperSlide key={game.uid}>
                <RecentGameItem game={game} />
            </SwiperSlide>
        );
    });

    const listInMobile: JSX.Element = (
        <div className={styles.list}>{recentGames}</div>
    );

    const listInDesktop: JSX.Element = (
        <div ref={swiperRef}>
            <Swiper
                slidesPerView={handleSwiperSlides()}
                onSlideChange={(swiper) => handleShadowIndicator(swiper.isEnd)}
                breakpoints={{
                    [BREAKPOINTS.LG]: {
                        spaceBetween: 60,
                    },
                    [BREAKPOINTS.XL]: {
                        spaceBetween: 30,
                    },
                    [BREAKPOINTS._2XXL]: {
                        spaceBetween: 60,
                    },
                }}
            >
                {recentGames}
            </Swiper>
        </div>
    );

    /* ClassNames */

    const shadowClasses: string = cn(styles.list__shadow, {
        [styles.endOfList]: lastElementReached,
    });

    return (
        <section className={cn(styles.container, className)}>
            <h2>Recent games</h2>
            <div>
                {ui.windowWidth < BREAKPOINTS.LG ? listInMobile : listInDesktop}
                <div className={shadowClasses} />
            </div>
            <Button
                className={styles.button}
                color="dark"
                onClick={() => console.log('loading...')}
                radius="normal"
            >
                See more
            </Button>
        </section>
    );
};
export default RecentGames;
